import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["course", "right"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import routes from "@/lib/routes";
import { ButtonLink } from "@/components/Buttons/index";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ContractButtonLink(_ref) {
  var course = _ref.course,
      right = _ref.right,
      props = _objectWithoutProperties(_ref, _excluded);

  var contractAllowed = (course === null || course === void 0 ? void 0 : course.contractAllowed) || (right === null || right === void 0 ? void 0 : right.contractAllowed);

  var _useMemo = useMemo(function () {
    if (contractAllowed) {
      return ["購入する", {
        fillColor: true
      }];
    } else {
      return ["販売終了", {
        fillGray: true
      }];
    }
  }, [contractAllowed]),
      text = _useMemo[0],
      color = _useMemo[1];

  var href = useMemo(function () {
    if (course) {
      return routes.svodPaymentStep(course.id, 1);
    } else if (right) {
      return routes.subscriptionByRight(right.id);
    }
  }, [course, right]);
  if (!href) return null;
  return /*#__PURE__*/_jsx(ButtonLink, _objectSpread(_objectSpread(_objectSpread({
    href: href,
    disabled: !contractAllowed
  }, color), props), {}, {
    children: text
  }));
}